/*
 * Copyright (c) 2017, Indigen Solutions. All rights reserved.
 *
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 *
 * This software is the confidential and proprietary information.
 *
 * You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement
 * you entered into.
 */

import { Model } from "../utils/json-api";
import { Customer } from "../types/Customer";

/**
 *
 */
export class UserData implements Model {

    static get TYPE() {
        return "UserData";
    }

    id?: string;
    userId: string;
    customers: { [customerId: string]: Customer };
}


// WEBPACK FOOTER //
// ./src/models/UserData.model.ts